import { API } from '../constants';
import { ApiService } from './api.service';

export const PositionService = {
  getPositions: () => {
    return ApiService.get(API.GET.POSITION.GET);
  },
};
